<template>
  <div class="tw:sm:mx-4 tw:md:mx-0 tw:w-full">
    <div v-if="isInitialDataLoading" class="tw:rounded-xl tw:animate-pulse tw:bg-gray-300 tw:h-[658px]"></div>
    <div v-else-if="isError">
      <p class="tw:text-center tw:text-xl">{{ $t('onboarding.appLaunchError.header') }}</p>
    </div>

    <SmartBoostContainer selectedTab="history" />
    <FullScreenLoader v-show="isFetching" />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue'

import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'
import SmartBoostContainer from '@/components/rateConnect/smartBoost/SmartBoostContainer.vue'

import { useActiveBoosts, useBoostsHistory, useCampaign } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { isCampaignsDataInitialLoading, isError, isFetching } = useCampaign(selectedAccommodationId)
const { isActiveBoostsLoading } = useActiveBoosts(selectedAccommodationId)
const { isBoostsHistoryLoading } = useBoostsHistory(selectedAccommodationId)

const isInitialDataLoading: ComputedRef<boolean> = computed(
  () => isCampaignsDataInitialLoading.value || isActiveBoostsLoading.value || isBoostsHistoryLoading.value
)
</script>
